var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ativo
    ? _c(
        "div",
        { staticClass: "gt-host" },
        [
          _vm.estiloDoVeu
            ? _c("div", { staticClass: "gt-host__veu", style: _vm.estiloDoVeu })
            : _vm._e(),
          _vm.mostraFuro
            ? _c("div", {
                staticClass: "gt-host__furo",
                style: _vm.estiloDoFuro
              })
            : _vm._e(),
          _c("GuidedTourCursor", {
            attrs: {
              point: _vm.pontoDoCursor,
              visible: _vm.mostraCursor,
              "click-token": _vm.clickToken
            }
          }),
          _c(
            "div",
            { staticClass: "gt-host__card", style: _vm.estiloDoCard },
            [
              _c("GuidedTourCard", {
                attrs: {
                  titulo: _vm.tituloDoPasso,
                  detalhe: _vm.detalheDoPasso,
                  indice: _vm.indice,
                  total: _vm.total,
                  fase: _vm.fase,
                  "proxima-etapa": _vm.proximaEtapa,
                  "marcar-concluida": _vm.marcarConcluida,
                  marcando: _vm.marcando,
                  "drawer-aberto": _vm.drawerAberto,
                  "aguarda-acao": _vm.passoConcluiPorAcao
                },
                on: {
                  medido: _vm.aoMedirCard,
                  proximo: _vm.aoPedirProximo,
                  anterior: function($event) {
                    return _vm.$emit("voltar")
                  },
                  fechar: function($event) {
                    return _vm.$emit("fechar")
                  },
                  "alternar-drawer": function($event) {
                    return _vm.$emit("alternar-drawer")
                  },
                  "proxima-etapa": function($event) {
                    return _vm.$emit("proxima-etapa")
                  },
                  "update:marcarConcluida": function($event) {
                    return _vm.$emit("update:marcarConcluida", $event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }